import { ReactNode } from 'react'
import { Sidebar } from '../Sidebar/Sidebar'

interface AppLayoutProps {
  children: ReactNode
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className='min-h-screen bg-gray-50'>
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content - offset by sidebar width */}
      <div className='ml-16 min-h-screen transition-all duration-300'>
        {children}
      </div>
    </div>
  )
}
